var _rect, _rect2, _g, _rect3, _path, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpdate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 232,
  height: 142,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 232,
  height: 142,
  fill: "#C1CFFA",
  opacity: 0.6,
  rx: 12
})), /*#__PURE__*/React.createElement("mask", {
  id: "update_svg__a",
  width: 232,
  height: 142,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 232,
  height: 142,
  fill: "#E6E6E6",
  rx: 12
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#update_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#454545",
  strokeWidth: 2,
  d: "M83 22h66c6.075 0 11 4.925 11 11v110H72V33c0-6.075 4.925-11 11-11Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3259D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M116 60.5V71l3.5-3.5M116 71l-3.5-3.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3259D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M103.75 78v-7c0-3.517 0-6.422 5.25-6.93M128.25 78v-7c0-3.517 0-6.422-5.25-6.93"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M107.25 78c-7 0-7 3.132-7 7v1.75c0 4.83 0 8.75 8.75 8.75h14c7 0 8.75-3.92 8.75-8.75V85c0-3.868 0-7-7-7-1.75 0-2.24.368-3.15 1.05l-1.785 1.89c-2.065 2.205-5.565 2.205-7.647 0l-1.768-1.89c-.91-.682-1.4-1.05-3.15-1.05Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 3,
  x: 95,
  y: 105,
  fill: "#FDDBD7",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 3,
  x: 95,
  y: 105,
  fill: "#F56B57",
  rx: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 30,
  r: 3,
  fill: "#454545"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2C94C",
  fillRule: "evenodd",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M78 117c-8.284 0-15-6.716-15-15 0 8.284-6.716 15-15 15 8.284 0 15 6.716 15 15 0-8.284 6.716-15 15-15v0ZM188 40c-8.284 0-15-6.716-15-15 0 8.284-6.716 15-15 15 8.284 0 15 6.716 15 15 0-8.284 6.716-15 15-15v0Z",
  clipRule: "evenodd"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 22,
  x: 142,
  y: 105,
  fill: "#F8B24F",
  rx: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  d: "M155.508 120.12c-.584 0-1.1-.076-1.548-.228a2.958 2.958 0 0 1-1.116-.672 2.871 2.871 0 0 1-.684-1.128c-.152-.448-.228-.968-.228-1.56v-4.308c0-.264.064-.46.192-.588.136-.128.328-.192.576-.192.248 0 .436.064.564.192.136.128.204.324.204.588v4.296c0 .76.172 1.332.516 1.716.352.376.86.564 1.524.564s1.168-.188 1.512-.564c.344-.384.516-.956.516-1.716v-4.296c0-.264.064-.46.192-.588.136-.128.328-.192.576-.192.24 0 .424.064.552.192.136.128.204.324.204.588v4.308c0 .784-.136 1.444-.408 1.98-.264.536-.66.94-1.188 1.212-.528.264-1.18.396-1.956.396Zm5.944 2.136c-.24 0-.424-.064-.552-.192-.128-.128-.192-.316-.192-.564v-6.708c0-.248.064-.436.192-.564.128-.128.308-.192.54-.192.24 0 .424.064.552.192.128.128.192.316.192.564v.936l-.132-.36c.12-.408.364-.736.732-.984a2.32 2.32 0 0 1 1.308-.372c.512 0 .96.124 1.344.372.392.248.696.6.912 1.056.216.448.324.988.324 1.62 0 .624-.108 1.168-.324 1.632a2.49 2.49 0 0 1-.9 1.056c-.384.248-.836.372-1.356.372-.488 0-.916-.12-1.284-.36a1.82 1.82 0 0 1-.744-.96h.144v2.7c0 .248-.068.436-.204.564-.128.128-.312.192-.552.192Zm2.22-3.276c.296 0 .556-.072.78-.216.224-.144.396-.356.516-.636.128-.288.192-.644.192-1.068 0-.64-.136-1.116-.408-1.428-.272-.32-.632-.48-1.08-.48a1.41 1.41 0 0 0-.78.216c-.224.136-.4.348-.528.636-.12.28-.18.632-.18 1.056 0 .632.136 1.112.408 1.44.272.32.632.48 1.08.48Zm6.487 1.14c-.512 0-.964-.124-1.356-.372a2.49 2.49 0 0 1-.9-1.056c-.216-.464-.324-1.008-.324-1.632 0-.632.108-1.172.324-1.62a2.49 2.49 0 0 1 .9-1.056 2.482 2.482 0 0 1 1.356-.372c.488 0 .912.12 1.272.36.368.24.616.556.744.948h-.132v-3.12c0-.248.064-.436.192-.564.128-.128.312-.192.552-.192.24 0 .424.064.552.192.136.128.204.316.204.564v7.128c0 .248-.064.44-.192.576-.128.128-.312.192-.552.192-.24 0-.424-.064-.552-.192-.128-.136-.192-.328-.192-.576v-.936l.132.36c-.12.416-.364.748-.732.996s-.8.372-1.296.372Zm.42-1.14c.296 0 .556-.072.78-.216.224-.144.396-.356.516-.636.128-.288.192-.644.192-1.068 0-.64-.136-1.116-.408-1.428-.272-.32-.632-.48-1.08-.48a1.41 1.41 0 0 0-.78.216c-.224.136-.4.348-.528.636-.12.28-.18.632-.18 1.056 0 .632.136 1.112.408 1.44.272.32.632.48 1.08.48Zm6.451 1.14a2.62 2.62 0 0 1-1.14-.24 2.067 2.067 0 0 1-.78-.672 1.688 1.688 0 0 1-.276-.948c0-.432.112-.772.336-1.02.224-.256.588-.44 1.092-.552.504-.112 1.18-.168 2.028-.168h.6v.864h-.588c-.496 0-.892.024-1.188.072-.296.048-.508.132-.636.252-.12.112-.18.272-.18.48 0 .264.092.48.276.648.184.168.44.252.768.252.264 0 .496-.06.696-.18.208-.128.372-.3.492-.516.12-.216.18-.464.18-.744v-1.38c0-.4-.088-.688-.264-.864-.176-.176-.472-.264-.888-.264a3.766 3.766 0 0 0-1.596.372c-.152.072-.288.092-.408.06a.459.459 0 0 1-.264-.192.63.63 0 0 1-.096-.336c0-.12.032-.236.096-.348a.572.572 0 0 1 .324-.264c.368-.152.72-.26 1.056-.324a5.16 5.16 0 0 1 .936-.096c.576 0 1.048.088 1.416.264.376.176.656.444.84.804.184.352.276.808.276 1.368v2.88c0 .248-.06.44-.18.576-.12.128-.292.192-.516.192-.224 0-.4-.064-.528-.192-.12-.136-.18-.328-.18-.576v-.576h.096a1.627 1.627 0 0 1-.948 1.2 2.05 2.05 0 0 1-.852.168Zm7.319 0c-.52 0-.956-.088-1.308-.264a1.7 1.7 0 0 1-.768-.768c-.168-.344-.252-.768-.252-1.272v-2.556h-.624c-.192 0-.34-.048-.444-.144a.568.568 0 0 1-.156-.42c0-.184.052-.324.156-.42.104-.096.252-.144.444-.144h.624v-1.092c0-.248.064-.436.192-.564.136-.128.324-.192.564-.192.24 0 .424.064.552.192.128.128.192.316.192.564v1.092h1.272c.192 0 .34.048.444.144.104.096.156.236.156.42a.568.568 0 0 1-.156.42c-.104.096-.252.144-.444.144h-1.272v2.472c0 .384.084.672.252.864.168.192.44.288.816.288.136 0 .256-.012.36-.036.104-.024.196-.04.276-.048a.275.275 0 0 1 .24.096c.064.064.096.2.096.408 0 .16-.028.304-.084.432a.435.435 0 0 1-.276.252c-.104.032-.24.06-.408.084a2.409 2.409 0 0 1-.444.048Zm4.751 0c-.664 0-1.236-.124-1.716-.372s-.852-.6-1.116-1.056c-.256-.456-.384-.996-.384-1.62 0-.608.124-1.14.372-1.596a2.79 2.79 0 0 1 1.044-1.068 2.945 2.945 0 0 1 1.524-.396c.416 0 .788.068 1.116.204.336.136.62.332.852.588.24.256.42.568.54.936.128.36.192.768.192 1.224a.4.4 0 0 1-.156.336c-.096.072-.236.108-.42.108h-3.852v-.864h3.372l-.192.18c0-.368-.056-.676-.168-.924a1.171 1.171 0 0 0-.468-.564c-.2-.136-.452-.204-.756-.204-.336 0-.624.08-.864.24a1.484 1.484 0 0 0-.54.66c-.12.28-.18.616-.18 1.008v.084c0 .656.152 1.148.456 1.476.312.32.768.48 1.368.48.208 0 .44-.024.696-.072.264-.056.512-.148.744-.276.168-.096.316-.136.444-.12a.42.42 0 0 1 .3.132c.08.08.128.18.144.3a.562.562 0 0 1-.072.348.742.742 0 0 1-.3.312 3.22 3.22 0 0 1-.972.396c-.36.08-.696.12-1.008.12Z"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 22,
  x: 142,
  y: 105,
  stroke: "#454545",
  strokeWidth: 2,
  rx: 11
})));
export default SvgUpdate;